"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _core = require("@material-ui/core");
var _MoreHoriz = _interopRequireDefault(require("@material-ui/icons/MoreHoriz"));
var _reactRouterDom = require("react-router-dom");
var _react = _interopRequireWildcard(require("react"));
var _lodash = _interopRequireDefault(require("lodash"));
var _Translations = require("react-platform-components/dist/Translations");
var _reactRedux = require("react-redux");
var _CreateBankAccount = _interopRequireDefault(require("./dialogs/CreateBankAccount"));
var _Payout = _interopRequireDefault(require("./dialogs/Payout"));
var _TransactionsActions = require("./TransactionsActions");
var _reactUse = require("react-use");
var _index = require("react-platform-components/dist/helpers/index");
var _ConfrimationDialog = require("react-platform-components/dist/components/ConfrimationDialog/ConfrimationDialog");
var _styles = require("@material-ui/core/styles");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    tableContainer: _defineProperty({
      marginTop: 20,
      width: '100vw'
    }, theme.breakpoints.up("md"), {
      margin: 50,
      width: 'auto'
    }),
    table: {
      minWidth: 300
    },
    header: _defineProperty({
      margin: 10,
      width: 'auto'
    }, theme.breakpoints.up("md"), {
      margin: 50
    })
  };
});
function Transactions(props) {
  (0, _reactUse.useTitle)(props.intl.formatMessage({
    id: "Transactions page title",
    defaultMessage: "Transactions page title"
  }));
  var dispatch = (0, _reactRedux.useDispatch)();
  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
      return {
        totalTransactions: state.transactionsReducer.totalTransactions,
        transactions: state.transactionsReducer.transactions,
        user: state.auth.user
      };
    }),
    totalTransactions = _useSelector.totalTransactions,
    transactions = _useSelector.transactions,
    user = _useSelector.user;
  var _useState = (0, _react.useState)({
      isCreateBankAccountDialogOpen: false,
      isFeedWalletDialogOpen: false,
      isPayoutDialogOpen: false,
      isTransactionDetailDialogOpen: false,
      selectedTransaction: null,
      transactionPage: 0,
      transactionPerPage: 10,
      wallet: {}
    }),
    _useState2 = _slicedToArray(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];
  var history = (0, _reactRouterDom.useHistory)();
  var classes = useStyles();
  (0, _react.useEffect)(function () {
    fetchTransactions(state.transactionPage, state.transactionPerPage);
    dispatch({
      type: 'FETCH_USER',
      params: {
        _embed: 'wallets'
      }
    });
  }, []);
  (0, _react.useEffect)(function () {
    var _user$wallets;
    var walletIndex = (_user$wallets = user.wallets) === null || _user$wallets === void 0 ? void 0 : _user$wallets.findIndex(function (wallet) {
      return wallet.type === 'DEFAULT';
    });
    if (walletIndex > -1) setState(_objectSpread(_objectSpread({}, state), {}, {
      wallet: user.wallets[walletIndex]
    }));
  }, [user.wallets]);
  (0, _react.useEffect)(function () {}, [user === null || user === void 0 ? void 0 : user.mpay_extension.kyc_level]);
  var handlerPageChanged = function handlerPageChanged(event, page) {
    setState(_objectSpread(_objectSpread({}, state), {}, {
      transactionPage: page
    }));
    fetchTransactions(page, state.transactionPerPage);
  };
  var handlerPerPageChanged = function handlerPerPageChanged(event) {
    var perPage = event.target.value;
    setState(_objectSpread(_objectSpread({}, state), {}, {
      transactionPerPage: perPage
    }));
    fetchTransactions(state.transactionPage, perPage);
  };
  var handlerOpenPayoutDialog = function handlerOpenPayoutDialog(event) {
    if ((user === null || user === void 0 ? void 0 : user.mpay_extension.kyc_level) !== 'REGULAR') {
      props.onConfirm(function () {
        var to = user.mpay_extension.user_type === 'Legal' ? '/mangorpay-regular-legal-user' : '/mangorpay-regular-natural-user';
        history.push(to);
      }, {
        title: 'Your account mangopay is not completed yet, you must complete all the informations about the payment process',
        confirmLabel: 'Complete my account',
        disableCloseAction: true
      });
    } else {
      var _user$mpay_extension;
      if (user !== null && user !== void 0 && (_user$mpay_extension = user.mpay_extension) !== null && _user$mpay_extension !== void 0 && _user$mpay_extension.xmpay_id_default_bank_account) {
        setState(_objectSpread(_objectSpread({}, state), {}, {
          isPayoutDialogOpen: true
        }));
      } else {
        setState(_objectSpread(_objectSpread({}, state), {}, {
          isCreateBankAccountDialogOpen: true
        }));
      }
    }
  };
  var handlerPayoutDialogClosed = function handlerPayoutDialogClosed() {
    setState(_objectSpread(_objectSpread({}, state), {}, {
      isPayoutDialogOpen: false
    }));
  };
  var handlerCreateBankAccountDialogClosed = function handlerCreateBankAccountDialogClosed() {
    setState(_objectSpread(_objectSpread({}, state), {}, {
      isCreateBankAccountDialogOpen: false
    }));
  };
  function fetchTransactions(page, perPage, params) {
    dispatch({
      params: _objectSpread(_objectSpread({}, params), {}, {
        _page: page + 1,
        _per_page: perPage,
        _sort: '-created_at'
      }),
      type: _TransactionsActions.FETCH_TRANSACTIONS_START
    });
  }
  var handlerCloseSnackbar = function handlerCloseSnackbar(event) {
    dispatch({
      type: 'CLEAR_SUCCESS_MESSAGE'
    });
    dispatch({
      type: 'CLEAR_ERROR'
    });
  };
  var transactionPage = state.transactionPage,
    transactionPerPage = state.transactionPerPage,
    wallet = state.wallet;
  var intl = props.intl;
  return /*#__PURE__*/_react.default.createElement(_core.Grid, {
    className: "mt-8"
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    className: classes.header
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 8
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "caption",
    style: {
      fontSize: 20
    },
    gutterBottom: true
  }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Balance: ",
    defaultMessage: "Balance: "
  }), !_lodash.default.isEmpty(wallet) ? "".concat(wallet.available_balance, " ").concat(wallet.currency) : 0)), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    item: true,
    alignItems: "center",
    justify: "flex-end",
    xs: 4
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true
  }, /*#__PURE__*/_react.default.createElement(_core.Button, {
    variant: "contained",
    color: "primary",
    onClick: handlerOpenPayoutDialog
  }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Payout",
    defaultMessage: "Payout"
  }))))), /*#__PURE__*/_react.default.createElement(_core.Paper, {
    className: classes.tableContainer
  }, /*#__PURE__*/_react.default.createElement(_core.TableContainer, null, /*#__PURE__*/_react.default.createElement(_core.Table, {
    className: classes.table,
    "aria-label": "transactions table"
  }, /*#__PURE__*/_react.default.createElement(_core.TableHead, null, /*#__PURE__*/_react.default.createElement(_core.TableRow, null, /*#__PURE__*/_react.default.createElement(_core.TableCell, null, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Resource ID",
    defaultMessage: "Resource ID"
  })), /*#__PURE__*/_react.default.createElement(_core.TableCell, null, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Type de transaction",
    defaultMessage: "Type de transaction"
  })), /*#__PURE__*/_react.default.createElement(_core.TableCell, null, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Date",
    defaultMessage: "Date"
  })), /*#__PURE__*/_react.default.createElement(_core.TableCell, null, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Amount",
    defaultMessage: "Amount"
  })), /*#__PURE__*/_react.default.createElement(_core.TableCell, null, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Statut",
    defaultMessage: "Statut"
  })), /*#__PURE__*/_react.default.createElement(_core.TableCell, null))), /*#__PURE__*/_react.default.createElement(_core.TableBody, null, transactions.map(function (transaction) {
    return /*#__PURE__*/_react.default.createElement(_core.TableRow, {
      key: transaction.id,
      hover: true,
      tabIndex: -1
    }, /*#__PURE__*/_react.default.createElement(_core.TableCell, null, transaction.xmpay_id_transaction), /*#__PURE__*/_react.default.createElement(_core.TableCell, null, transaction.translated_type), /*#__PURE__*/_react.default.createElement(_core.TableCell, null, (0, _index.formatDate)(transaction.created_at)), /*#__PURE__*/_react.default.createElement(_core.TableCell, null, transaction.amount.toFixed(2) || 0), /*#__PURE__*/_react.default.createElement(_core.TableCell, null, transaction.translated_status || 0), /*#__PURE__*/_react.default.createElement(_core.TableCell, null, transaction.mgpay_wire_reference && /*#__PURE__*/_react.default.createElement(_core.Tooltip, {
      title: /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
        id: "Plus de d\xE9tail",
        defaultMessage: "Plus de d\xE9tail"
      })
    }, /*#__PURE__*/_react.default.createElement(_core.IconButton, {
      "aria-label": "delete"
    }, /*#__PURE__*/_react.default.createElement(_MoreHoriz.default, null)))));
  })))), /*#__PURE__*/_react.default.createElement(_core.TablePagination, {
    component: "div",
    count: totalTransactions,
    rowsPerPage: transactionPerPage,
    labelDisplayedRows: function labelDisplayedRows(_ref) {
      var from = _ref.from,
        to = _ref.to,
        count = _ref.count;
      return "".concat(from, "-").concat(to, " ").concat(intl.formatMessage({
        id: "of",
        defaultMessage: "of"
      }), " ").concat(count !== -1 ? count : intl.formatMessage({
        id: "more than {page}",
        defaultMessage: "more than {page}"
      }, {
        page: to
      }));
    },
    labelRowsPerPage: intl.formatMessage({
      id: 'Rows per page:',
      defaultMessage: 'Rows per page:'
    }),
    page: transactionPage,
    backIconButtonProps: {
      'aria-label': 'Previous Page'
    },
    nextIconButtonProps: {
      'aria-label': 'Next Page'
    },
    rowsPerPageOptions: [10, 25, 50],
    onChangePage: handlerPageChanged,
    onChangeRowsPerPage: handlerPerPageChanged
  })), /*#__PURE__*/_react.default.createElement(_Payout.default, {
    open: state.isPayoutDialogOpen,
    close: handlerPayoutDialogClosed
  }), /*#__PURE__*/_react.default.createElement(_CreateBankAccount.default, {
    open: state.isCreateBankAccountDialogOpen,
    close: handlerCreateBankAccountDialogClosed
  }));
}
var _default = (0, _Translations.injectIntl)((0, _ConfrimationDialog.withConfirmationDialog)(Transactions));
exports.default = _default;